/**
 * local-navigation behaviour. (hide on mobile if no child pages)
 */

(function (Drupal, $) {
  "use strict";

  /**
   * Mobile accordion toggle behavior for local navigation.
   * Handles the "In This Section" button on mobile for .local-navigation
   *
   * @type {{attach: Drupal.behaviors.accordionToggle.attach}}
   */
  Drupal.behaviors.accordionToggle = {
    attach: function (context, settings) {
      $('.local-navigation .accordion-toggle', context).once('custom-navigation-mobile').each(function () {
        var $toggle = $(this);
        var $navWrapper = $toggle.closest('.local-navigation');

        $toggle.on('click', function(e) {
          e.preventDefault();
          if(!$navWrapper.hasClass('open-in-this-section')) {
            $navWrapper.addClass('open-in-this-section');
            $toggle.attr('aria-expanded', 'true');
          } else {
            $navWrapper.removeClass('open-in-this-section');
            $toggle.attr('aria-expanded', 'false');
          }
        });
      });
    }
  };

  /**
   * Sidebar navigation behavior.
   * Handles initialization and desktop toggle icons for sidebar navigation.
   *
   * @type {{attach: Drupal.behaviors.sidebarNavigation.attach}}
   */
  Drupal.behaviors.sidebarNavigation = {
    attach: function (context, settings) {

      // ============================================
      // INITIALIZE: Hide all submenus not in active trail on page load
      // ============================================
      $('.local-navigation [data-collapsible-content]', context).once('sidebar-navigation-init').each(function () {
        var $navContainer = $(this);

        // Find all menu items with children (expanded or collapsed)
        $navContainer.find('.menu-item--expanded, .menu-item--collapsed').each(function() {
          var $menuItem = $(this);
          var $link = $menuItem.find('> a');
          var $submenu = $menuItem.find('> .menu.sub-nav');

          // Check if this item or any of its descendants are in the active trail
          var isInActiveTrail = $menuItem.hasClass('menu-item--active-trail') ||
                                $link.hasClass('is-active') ||
                                $menuItem.find('.is-active').length > 0;

          if (isInActiveTrail) {
            // Expand active trail items
            $link.addClass('is-active');
            $menuItem.addClass('menu-item--active-trail');
            $menuItem.removeClass('menu-item--collapsed').addClass('menu-item--expanded');
            $submenu.show(); // Show immediately on page load
            // Toggle icons
            $link.find('.toggle-icon.is-expended').show();
            $link.find('.toggle-icon.is-collapsed').hide();
          } else {
            // Collapse non-active items
            $link.removeClass('is-active');
            $menuItem.removeClass('menu-item--active-trail');
            $menuItem.removeClass('menu-item--expanded').addClass('menu-item--collapsed');
            $submenu.hide(); // Hide immediately on page load
            // Toggle icons
            $link.find('.toggle-icon.is-expended').hide();
            $link.find('.toggle-icon.is-collapsed').show();
          }
        });
      });

      // ============================================
      // Desktop toggle icons - works for sidebar navigation only
      // ============================================
      $('.local-navigation [data-collapsible-content]', context).once('sidebar-navigation-toggle').each(function () {
        var $navContainer = $(this); // Store reference to the navigation container

        // Find toggle icons within this specific container only
        $navContainer.find('.toggle-icon').on('click', function(e) {
          var $toggleIcon = $(this);
          var $link = $toggleIcon.closest('a');
          var $menuItem = $toggleIcon.closest('li.menu-item');
          // Find direct child submenu at any level
          var $submenu = $menuItem.find('> .menu.sub-nav');

          // Toggle only the current menu item (no accordion behavior)
          if($link.hasClass('is-active')) {
            $link.removeClass('is-active');
            $menuItem.removeClass('menu-item--active-trail');
            $menuItem.removeClass('menu-item--expanded').addClass('menu-item--collapsed');
            $submenu.slideUp();
            // Toggle icons: show collapsed, hide expanded
            $link.find('.toggle-icon.is-expended').hide();
            $link.find('.toggle-icon.is-collapsed').show();

            // Collapse all nested children at all levels
            $submenu.find('.menu.sub-nav').slideUp();
            $submenu.find('a.is-active').removeClass('is-active');
            $submenu.find('.menu-item--active-trail').removeClass('menu-item--active-trail');
            $submenu.find('.menu-item--expanded').removeClass('menu-item--expanded').addClass('menu-item--collapsed');
            // Toggle icons for all nested items
            $submenu.find('.toggle-icon.is-expended').hide();
            $submenu.find('.toggle-icon.is-collapsed').show();
          } else {
            $link.addClass('is-active');
            $menuItem.addClass('menu-item--active-trail');
            $menuItem.removeClass('menu-item--collapsed').addClass('menu-item--expanded');
            $submenu.slideDown();
            // Toggle icons: show expanded, hide collapsed
            $link.find('.toggle-icon.is-expended').show();
            $link.find('.toggle-icon.is-collapsed').hide();
          }

          e.preventDefault();
        });

      });
    }
  };

  /**
   * Magazine menu accordion toggle behavior.
   * Handles accordion-toggle buttons outside of .local-navigation (e.g. magazine sidebar menu).
   *
   * @type {{attach: Drupal.behaviors.magazineMenuToggle.attach}}
   */
  Drupal.behaviors.magazineMenuToggle = {
    attach: function (context, settings) {
      var LG_BREAKPOINT = 992;

      $('[data-collapsible-toggle]', context).not('.local-navigation [data-collapsible-toggle]').once('custom-navigation-mobile').each(function () {
        var $toggle = $(this);
        var contentId = $toggle.attr('aria-controls');
        var $contentWrapper = contentId ? $('#' + contentId) : $toggle.siblings('[data-collapsible-content]');

        function applyBreakpointState() {
          if (window.innerWidth >= LG_BREAKPOINT) {
            $toggle.addClass('is-open').attr('aria-expanded', 'true');
            $contentWrapper.show();
          } else {
            $toggle.removeClass('is-open').attr('aria-expanded', 'false');
            $contentWrapper.hide();
          }
        }

        // Set initial state without animation.
        applyBreakpointState();

        $toggle.on('click', function (e) {
          e.preventDefault();
          var expanded = $toggle.attr('aria-expanded') === 'true';
          if (expanded) {
            $toggle.removeClass('is-open').attr('aria-expanded', 'false');
            $contentWrapper.slideUp();
          } else {
            $toggle.addClass('is-open').attr('aria-expanded', 'true');
            $contentWrapper.slideDown();
          }
        });

        $(window).on('resize.magazineMenuToggle', function () {
          applyBreakpointState();
        });
      });
    }
  };

  /**
   * Magazine menu toggle height CSS variable.
   * Sets --accordion-toggle-height on .block-views-blockmagazine-menu-block-1
   * based on the measured height of its .accordion-toggle element.
   *
   * @type {{attach: Drupal.behaviors.magazineMenuToggleHeight.attach}}
   */
  Drupal.behaviors.magazineMenuToggleHeight = {
    attach: function (context, settings) {
      var $block = $('.block-views-blockmagazine-menu-block-1', context).once('magazine-toggle-height');

      if (!$block.length) return;

      function setToggleHeight() {
        $block.each(function () {
          var $b = $(this);
          var height = $b.find('.accordion-toggle').outerHeight();
          if (height) {
            $b[0].style.setProperty('--accordion-toggle-height', height + 'px');
          }
        });
      }

      setToggleHeight();

      $(window).on('resize.magazineToggleHeight', function () {
        setToggleHeight();
      });
    }
  };

})(Drupal, jQuery);
